var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJpgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 0H4.5C3.30653 0 2.16193 0.421427 1.31802 1.17157C0.474106 1.92172 0 2.93913 0 4V36C0 37.0609 0.474106 38.0783 1.31802 38.8284C2.16193 39.5786 3.30653 40 4.5 40H31.5C32.6935 40 33.8381 39.5786 34.682 38.8284C35.5259 38.0783 36 37.0609 36 36V12L22.5 0ZM11.7878 28.892C11.7878 31.196 10.548 32 8.55225 32C8.07975 32 7.45875 31.928 7.056 31.806L7.28325 30.332C7.569 30.416 7.9335 30.476 8.3385 30.476C9.2025 30.476 9.74025 30.128 9.74025 28.868V23.782H11.79V28.892H11.7878ZM19.1992 28.162C18.495 28.748 17.46 29.014 16.245 29.014C15.975 29.014 15.732 29 15.543 28.976V31.866H13.5045V23.89C14.4248 23.7668 15.3549 23.7113 16.2855 23.724C17.5522 23.724 18.4568 23.938 19.062 24.37C19.6448 24.778 20.0362 25.45 20.0362 26.242C20.0362 27.034 19.737 27.706 19.1992 28.162ZM28.944 31.496C28.314 31.688 27.1103 31.952 25.9088 31.952C24.2505 31.952 23.049 31.58 22.212 30.86C21.3772 30.164 20.9183 29.11 20.9295 27.922C20.9452 25.234 23.1413 23.7 26.1248 23.7C27.297 23.7 28.2038 23.906 28.647 24.096L28.2173 25.558C27.7178 25.366 27.099 25.21 26.1 25.21C24.3878 25.21 23.0895 26.074 23.0895 27.826C23.0895 29.492 24.2663 30.476 25.9492 30.476C26.424 30.476 26.7998 30.428 26.964 30.354V28.662H25.56V27.236H28.944V31.496ZM22.5 14H20.25V4L31.5 14H22.5Z",
    fill: "#103A5D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3912 25.1094C15.9727 25.1094 15.6892 25.1454 15.543 25.1814V27.5674C15.7162 27.6034 15.9345 27.6134 16.2337 27.6134C17.3227 27.6134 17.9977 27.1214 17.9977 26.2954C17.9977 25.5514 17.4195 25.1094 16.3912 25.1094Z",
    fill: "#103A5D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgIcon);
export default __webpack_public_path__ + "static/media/jpg-icon.2635fad9575389d27747a77128bc5c5c.svg";
export { ForwardRef as ReactComponent };